import { Button } from "@mui/material"
import Iconify from "minimals-template/components/Iconify"

export function AuthoringCollapseAllToggle({ expanded, onToggle, label, dataCy }) {
    const icon = expanded ? "ic:round-unfold-less" : "ic:round-unfold-more"
    const caption = expanded ? `Collapse ${label}` : `Expand ${label}`

    return (
        <Button
            size="small"
            variant="text"
            onClick={onToggle}
            startIcon={<Iconify icon={icon} />}
            data-cy={dataCy}
            sx={{ pl: 0 }}
        >
            {caption}
        </Button>
    )
}
